// src/firebase.js
// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken as getAppCheckToken,
} from "firebase/app-check";
import { getAnalytics, isSupported } from "firebase/analytics";

// ───────────────────────────────────────────────────────────────
// Local debug token for App Check (dev only; does not affect prod)
if (
  typeof window !== "undefined" &&
  window.location?.hostname?.startsWith("localhost")
) {
  // You can keep your static token; true works as well.
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = "9f14bcd3-7b2a-4e6a-8f65-2c47d71e3a12";
}
// ───────────────────────────────────────────────────────────────

const firebaseConfig = {
  apiKey: "AIzaSyBMK29jfw6v8iDhxtju7uw3AmGq8Q-Udj0",
  authDomain: "healthmonitorapp-5d3e3.firebaseapp.com",
  projectId: "healthmonitorapp-5d3e3",
  storageBucket: "healthmonitorapp-5d3e3.appspot.com",
  messagingSenderId: "55362241003",
  appId: "1:55362241003:web:22f4476b967bb0f3f419ae",
  measurementId: "G-HR5V76M0EE",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ───────────────────────────────────────────────────────────────
// App Check MUST be initialized before any Auth/Firestore usage
// Make sure the Site key below belongs to the same web app as the appId above.
if (typeof window !== "undefined" && !window.__appCheckInitialized) {
  const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6Lf2ucErAAAAAKG29g1DaJ8H0oBX42zDv6ME1oah"), // ← your SITE KEY
    isTokenAutoRefreshEnabled: true,
  });
  window.__appCheckInitialized = true;
  window.__appCheck = appCheck; // optional: handy for debugging in DevTools

  // One-time proof in production that a token is issued
  getAppCheckToken(appCheck, /* forceRefresh */ true)
    .then((res) => {
      console.log("✅ AppCheck token length:", res?.token?.length ?? 0);
    })
    .catch((err) => {
      console.error("❌ AppCheck token error:", err);
    });

  console.log("🔥 App Check initialized for appId:", firebaseConfig.appId);
}
// ───────────────────────────────────────────────────────────────

export const auth = getAuth(app);
export const db = getFirestore(app);

// Analytics (loads only where supported, e.g., browsers; safe on server)
let analytics = null;
if (typeof window !== "undefined") {
  isSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app);
  });
}
export { analytics };
